const theme = {
  background: "#F1EFEAE5",
  borderHeader: "#E1E0E0",
  primary: "#000",
  secondary: "#79716B",
  constellationLogoColor: "#2D3FD8",
  menuLabelColor: "#FFF",

  optionsHeaderPrimary: "#292D3A",
  optionsHeaderPrimaryDarken: "#252935",

  getDagGlowColor: "#1552EF",

  optionsDateAndButtonColor: "#BDB4FE",

  linkIconColor: "#252935",

  borderColor: "#252935",

  redirectLinkBackground: "#3E1C96",

  sidebarBorderHeader: "#272B39",

  footerMailColor: "#2637D3",
  footerLinksHeaderColor: "#A9A29D",

  blogFiltersColor: "#97763F",

  marginBlogTopColor: "#9B9B9B",

  footerSocialMediaIconColor: "#6E717F",

  breakpoints: {
    mobile: "only screen and (max-width: 600px)",
    tablet: "only screen and (max-width: 1200px)",
    smallMobile: "only screen and (max-width: 300px)"
  },
};

export default theme;
